// extracted by mini-css-extract-plugin
module.exports = {"select":"Dropdown_select__2cTqN"};